import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M21.988 11.7A10.64 10.64 0 0 0 11.994 5a10.64 10.64 0 0 0-9.934 6.67A1 1 0 0 0 2 12q0 .161.06.31A10.64 10.64 0 0 0 11.994 19a10.64 10.64 0 0 0 9.934-6.67.8.8 0 0 0 .06-.33q.024-.15 0-.3M11.994 17a8.81 8.81 0 0 1-7.925-5 8.784 8.784 0 0 1 15.85 0 8.81 8.81 0 0 1-7.925 5m-2.998-5a3 3 0 1 1 2.998 3 3 3 0 0 1-2.998-3",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }